import { buildArticle } from "./_articleBuilder";

export default buildArticle({
  slug: "how-fast-can-depression-treatment-start-working",
  title: "How Fast Can Depression Treatment Start Working?",
  description:
    "How quickly different depression treatments may begin to work — TMS, SAINT®, SPRAVATO®, and medication. Individual results vary, and timelines differ by treatment.",
  keywords:
    "how fast depression treatment works, TMS timeline, SPRAVATO timeline, depression treatment speed",
  badge: "Educational Article",
  heroTitle: "How Fast Can Depression Treatment Start Working?",
  heroSubtitle:
    "One of the most common questions people ask is how quickly they might notice a difference. The honest answer is that it depends on the treatment and the person.",
  sections: [
    {
      heading: "There Is No Single Timeline",
      body: "Different treatments work on different timelines. Some people notice changes within days; others take weeks. Individual results vary, and no treatment guarantees a specific speed of response.",
    },
    {
      heading: "Oral Antidepressants",
      body: "Oral antidepressants typically take several weeks to reach full effect. Some people notice partial improvement earlier, but the standard guidance is to allow adequate time before assessing whether a medication is working.",
    },
    {
      heading: "TMS",
      body: "Traditional TMS involves sessions over several weeks, and people may notice changes at different points during the course. Some notice improvement partway through; others notice it after completing the course.",
    },
    {
      heading: "SAINT® and Accelerated TMS",
      body: "SAINT® compresses treatment into five consecutive days. Because the schedule is accelerated, the timeline for noticing changes may be different from traditional TMS. Whether and when you might notice a difference is a clinical discussion.",
    },
    {
      heading: "SPRAVATO®",
      body: "SPRAVATO® is given in a structured schedule that starts twice weekly and tapers. Some people report noticing changes during the early weeks of treatment. Individual response varies.",
    },
    {
      heading: "What This Means for You",
      body: "If you're wondering when you might feel different, that's a question worth bringing to a consultation. Your clinician can discuss what to expect based on the treatment being considered and your individual situation.",
      callout: true,
    },
  ],
  faq: [
    {
      question: "Will I feel better right away?",
      answer:
        "Not necessarily. Different treatments work on different timelines, and individual response varies. Some people notice changes quickly; others take longer. Your clinician can discuss what to expect.",
    },
    {
      question: "Which treatment works fastest?",
      answer:
        "There is no single fastest treatment. Accelerated protocols like SAINT® compress the schedule, but speed of response varies by individual. The right treatment depends on your situation, not just speed.",
    },
  ],
  related: [
    {
      title: "Depression Treatment Options",
      href: "/depression-treatment-options",
    },
    {
      title: "How Many TMS Sessions Are Needed?",
      href: "/how-many-tms-sessions",
    },
    { title: "What TMS Feels Like", href: "/what-tms-feels-like" },
  ],
  finalCtaText:
    "Questions about timelines are normal. Speak with our team about what to expect from different treatment options.",
});
